import * as setup from '@/setup';
import Button from '@/objects/button';

export default class ChallengeResult extends Phaser.Scene {
	constructor() {
		super({key: 'ChallengeResult'});
	}

	create(data) {
		const centerX = this.sys.game.config.width / 2;
		const centerY = this.sys.game.config.height / 2;

		// Titolo
		this.add.text(
			centerX,
			centerY - 200,
			'Risultato Sfida',
			{...setup.styles.gameOver.greetingStyle, fontSize: 36, fill: '#FFFFFF'}
		).setOrigin(0.5);

		if (!data || !data.result) {
			this.showError('Dati risultato non disponibili');
			return;
		}

		const result = data.result;
		const challenger = result.challenger;
		const challenged = result.challenged;

		// Nome sfidante
		const challengerName = challenger.user ? (challenger.user.nickname || `Utente ${challenger.user.id}`) : 'Sfidante';
		this.add.text(
			centerX - 100,
			centerY - 100,
			challengerName,
			{...setup.styles.gameOver.greetingStyle, fontSize: 24, fill: '#FFFFFF'}
		).setOrigin(0.5);

		// Punteggio sfidante
		this.add.text(
			centerX - 100,
			centerY - 50,
			`Punteggio: ${challenger.score}`,
			{...setup.styles.gameOver.greetingStyle, fontSize: 20, fill: '#FFFF00'}
		).setOrigin(0.5);

		// Nome sfidato
		const challengedName = challenged.user ? (challenged.user.nickname || `Utente ${challenged.user.id}`) : 'Sfidato';
		this.add.text(
			centerX + 100,
			centerY - 100,
			challengedName,
			{...setup.styles.gameOver.greetingStyle, fontSize: 24, fill: '#FFFFFF'}
		).setOrigin(0.5);

		// Punteggio sfidato
		this.add.text(
			centerX + 100,
			centerY - 50,
			`Punteggio: ${challenged.score}`,
			{...setup.styles.gameOver.greetingStyle, fontSize: 20, fill: '#FFFF00'}
		).setOrigin(0.5);

		// Vincitore
		let winnerText = '';
		let winnerColor = '#FFFFFF';
		if (result.winner === 'challenger') {
			winnerText = `${challengerName} vince!`;
			winnerColor = '#4CAF50';
		} else if (result.winner === 'challenged') {
			winnerText = `${challengedName} vince!`;
			winnerColor = '#4CAF50';
		} else {
			winnerText = 'Pareggio!';
			winnerColor = '#FFD700';
		}

		this.add.text(
			centerX,
			centerY + 50,
			winnerText,
			{...setup.styles.gameOver.greetingStyle, fontSize: 32, fill: winnerColor}
		).setOrigin(0.5);

		// Bottone torna al menu
		const menuButton = new Button(
			this,
			centerX,
			centerY + 150,
			'blue-button',
			1.5,
			'Torna al menu',
			false
		);

		menuButton.on('pointerup', () => {
			this.scene.start('Boot');
		});
	}

	showError(message) {
		const centerX = this.sys.game.config.width / 2;
		const centerY = this.sys.game.config.height / 2;
		
		this.add.text(
			centerX,
			centerY,
			message,
			{...setup.styles.gameOver.greetingStyle, fontSize: 24, fill: '#FF0000'}
		).setOrigin(0.5);

		// Bottone torna al menu
		const menuButton = new Button(
			this,
			centerX,
			centerY + 100,
			'red-button',
			1.2,
			'Torna al menu',
			false
		);

		menuButton.on('pointerup', () => {
			this.scene.start('Boot');
		});
	}
}
